"use strict";

var VellumJacket = require('../../products/components/VellumJacket');

var Inventory = require('./Inventory');

function inventoryVellumJackets(comps, date) {
  var components = comps.filter(function (comp) {
    return Object.prototype.isPrototypeOf.call(VellumJacket.prototype, comp);
  });
  var total = components.map(function (_ref) {
    var quantity = _ref.quantity;
    return quantity;
  }).reduce(function (p, v) {
    return p + v;
  }, 0);

  if (total) {
    return new Inventory({
      key: 'vellum_jackets',
      name: 'Vellum Jackets',
      unit: 'each',
      date: date,
      quantity: total
    });
  }

  return [];
}

module.exports = inventoryVellumJackets;